import BrainBuilderIcon from './component.jsx'
export default BrainBuilderIcon
